<template>
  <div class="table-operations" v-if="Statistic.total >= 0">
    <span
      style="cursor: pointer"
      @click="handleSearch({ status: statusList.map((x) => x.name) })"
    >
      <a-tooltip title="100%">
        <a-progress
          type="dashboard"
          :percent="100"
          :width="90"
          status="active"
          :format="() => Statistic.total"
        />
      </a-tooltip>
      <p>{{ $t("TOTAL") }}</p>
    </span>
    <a-divider type="vertical" style="height: 8em" />
    <template v-for="(item, name) in Statistic.details">
      <span
        style="cursor: pointer"
        @click="handleSearch({ status: [name] })"
        :key="name"
      >
        <a-tooltip :title="item.percent + '%'">
          <a-progress
            :strokeColor="item['color']"
            type="dashboard"
            :width="90"
            :percent="Number(item.percent)"
            :format="() => item.amount"
            status="active"
          />
        </a-tooltip>
        <p>{{ $t(name) }}</p>
      </span>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["handleSearch", "statusList"],
  computed: mapGetters(["Statistic"]),
};
</script>

<style>
</style>
